import styled from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {Input} from 'components/ui-kit/Input';
import {colors} from 'theme';

export const StyledInput = styled(Input)<{minWidth?: number}>`
    min-width: ${(p) => (p.minWidth ? `${p.minWidth}px` : '350px')};
`;

export const CancelIcon = styled(Icon)`
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translate(-100%, -50%);

    svg {
        stroke: ${colors.textSecondary};
    }

    :hover {
        svg {
            stroke: ${colors.textPrimary};
        }
    }
`;
